import { Component, OnInit, Input } from '@angular/core';
import { PlatformService } from "services/platform.service";

@Component({
	selector: 'ras-spinner',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.sass']
})
export class SpinnerComponent implements OnInit {

	private timer: any = null
	private message_timer: any = null

	public _messages: string[] = []
	@Input() set messages(value: string[]) {
		this._messages = value
		this.message_i = -1
		this.next_message()
	}
	get messages() {
		return this._messages
	}
	public message_i = 0
	public present = false
	public _active = false
	@Input() set active(value) {
		this._active = value
		if (this.platform.isBrowser) {
			if (value) {
				this.present = true
				if (this.timer != null) window.clearTimeout(this.timer)
				this.timer = null
			} else {
				if (this.timer != null) window.clearTimeout(this.timer)
				this.timer = window.setTimeout(() => {
					this.present = false
				}, 500)
			}
		}
		this.message_i = -1
		this.next_message()
	}

	next_message() {
		this.message_i += 1
		if (this.message_timer) clearTimeout(this.message_timer)
		this.message_timer = null
		if (!!this.messages && this.message_i >= this._messages.length) this.message_i = 0

		if (this._active && this._messages && this._messages.length > 1) this.message_timer = setTimeout(() => this.next_message(), 3000)
	}

	constructor(private platform: PlatformService) { }

	ngOnInit() {
	}

}
